import { useState } from "react";
import {
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  TablePagination,
} from "@mui/material";
import { MdAdd, MdDelete } from "react-icons/md";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { useGetDealersQuery } from "../../features/api/dealerApi";
import {
  useAllChallanQuery,
  useRemoveChallan2Mutation,
} from "../../features/api/challan2Api";
import { useRemoveChallanMutation } from "../../features/api/challanApi";

const Challan = () => {
  const { data: dlr } = useGetDealersQuery(null, {
    refetchOnMountOrArgChange: true,
  });
  const dealers = dlr?.dealer;

  const { data, isLoading } = useAllChallanQuery(null, {
    refetchOnMountOrArgChange: true,
  });

  const [removeChallan2] = useRemoveChallan2Mutation();
  const [removeChallan] = useRemoveChallanMutation();

  const handleDelete = async (id) => {
    console.log(id);
    const confirm = window.confirm("Are Your Sure?");
    if (confirm) {
      try {
        const result = await removeChallan2(id);
        console.log(result);
        if (!result?.error) {
          await removeChallan(id);
          toast.success("Delete Success..!!!");
        } else {
          toast.error(result?.error?.data?.error);
        }
      } catch (error) {
        console.log(error?.status);
      }
    }
  };

  const [searchTerm, setSearchTerm] = useState("");
  const [searchResults, setSearchResults] = useState([]);

  const handleSearchChange = (event) => {
    const searchTerm = event.target.value;
    setSearchTerm(searchTerm);

    const filteredResults = data?.filter((item) =>
      item?.ch_no.toLowerCase().includes(searchTerm.toLowerCase())
    );
    setSearchResults(filteredResults);
  };

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(20);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  function formatDate(dateString) {
    const date = new Date(dateString);
    let day = date.getDate();
    let month = date.getMonth() + 1;
    let year = date.getFullYear();
    let getDate = day + "-" + month + "-" + year;
    return getDate;
  }

  return (
    <div className="px-12">
      <div className="flex justify-between items-center py-4">
        <h1 className="text-xl font-bold">Challan</h1>
        <Link
          to="/dashboard/challan/create"
          className="text-white bg-blue-500 cursor-pointer flex items-center p-1"
        >
          {" "}
          <span>
            <MdAdd className="text-2xl" />
          </span>
          <span>New Challan</span>
        </Link>
      </div>
      <input
        type="text"
        placeholder="Search items"
        className="border focus:outline-none h-10 w-[250px] mb-3 rounded p-1 bg-slate-50"
        value={searchTerm}
        onChange={handleSearchChange}
      />
      <div className="py-2">
        {isLoading ? (
          <div className="w-fll h-screen flex flex-col items-center justify-center">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-gray-900"></div>
          </div>
        ) : data?.length === 0 ? (
          <p className=" text-xl text-red-500 mt-20 ml-20">
            There are no challan
          </p>
        ) : (
          <TableContainer
            component={Paper}
            // style={{ backgroundColor: "#f0f0f5" }}
          >
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  {/* <TableCell>
                    <span className="font-bold">Sl No.</span>
                  </TableCell> */}
                  <TableCell style={{ backgroundColor: "#f0f0f5" }}>
                    <span className="font-bold">Challan No.</span>
                  </TableCell>
                  <TableCell style={{ backgroundColor: "#f0f0f5" }}>
                    <span className="font-bold">Challan Date</span>
                  </TableCell>
                  <TableCell style={{ backgroundColor: "#f0f0f5" }}>
                    <span className="font-bold">Invoice no</span>
                  </TableCell>
                  <TableCell style={{ backgroundColor: "#f0f0f5" }}>
                    <span className="font-bold">Client Name</span>
                  </TableCell>
                  {/* <TableCell style={{ backgroundColor: "#f0f0f5" }}>
                    <span className="font-bold">Action</span>
                  </TableCell> */}
                  <TableCell style={{ backgroundColor: "#f0f0f5" }}>
                    <span className="font-bold">Report</span>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {data
                  ?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  ?.map((row, i) => {
                    return (
                      <TableRow key={row?.id}>
                        <TableCell>{row?.ch_no}</TableCell>
                        <TableCell>{formatDate(row?.ch_date)}</TableCell>
                        <TableCell>{row?.inv_no}</TableCell>
                        <TableCell>{row?.customer}</TableCell>
                        {/* <TableCell className="">
                              <div className="flex items-center gap-x-4">
                                <span onClick={() => handleDelete(row?.ch_no)}>
                                  <MdDelete className="text-xl text-red-500 font-bold cursor-pointer" />
                                </span>
                              </div>
                            </TableCell> */}
                        <TableCell className="">
                          <div className="flex items-center gap-x-4">
                            <Link to={`/dashboard/challan/report/${row?.id}`}>
                              <span className=" underline text-blue-600">
                                View
                              </span>
                            </Link>
                          </div>
                        </TableCell>
                      </TableRow>
                    );
                  })}
              </TableBody>
            </Table>
            <TablePagination
              style={{ backgroundColor: "#f0f0f5" }}
              rowsPerPageOptions={[20, 30, 50]}
              component="div"
              count={data?.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </TableContainer>
        )}
      </div>
    </div>
  );
};

export default Challan;
